import { render, staticRenderFns } from "./NarasuCampaign202308.vue?vue&type=template&id=12d60405&"
import script from "./NarasuCampaign202308.vue?vue&type=script&lang=js&"
export * from "./NarasuCampaign202308.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports